"use client";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { JSX } from "react";

const tailwindWrap = "w-full h-full flex items-center justify-center";
const GOOGLE_MAP_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY as string;

/**
 * google mapをラップしたコンポーネント
 * @props children GoogleMapパーツで出来たJSX
 */
const GoogleMap = ({ children, loading = false }: { children?: JSX.Element; loading?: boolean }) => {
  if (typeof window === "undefined") return <></>;

  const render = (status: Status) => {
    if (loading) {
      return <div className="h-full w-full bg-gray bg-opacity-25" />;
    }

    switch (status) {
      case Status.LOADING:
        return <div className="h-full w-full bg-gray bg-opacity-25" />; //loadingコンポーネントを使用する場合にかなりちらつくのでやめる
      case Status.FAILURE:
        return (
          <div className={tailwindWrap}>
            <span>Error</span>
          </div>
        );
      case Status.SUCCESS:
        return <div className={tailwindWrap}>{children}</div>;
    }
  };

  return <Wrapper apiKey={GOOGLE_MAP_API_KEY} render={render} />;
};

export default GoogleMap;
